const menu = {
  main: function () {
    this.sortMenu();
    this.mobileToggle();
    this.subMenuToggle();
    this.toggleSearch();
    this.searchView();
    this.clearSearch();
    this.closeMenu();
  },
  mobileToggle: function () {
    const buttonMenu = document.querySelector('button.menu__toggle');

    if (!buttonMenu) return;

    buttonMenu.addEventListener('click', function () {
      this.classList.toggle('menu__toggle--open');
      document.querySelector('div.menu').classList.toggle('menu--open');
    });
  },
  subMenuToggle: function () {
    const links = document.querySelectorAll('.menu > nav > ul > li > a');

    function handleClick(event) {
      const href = event.currentTarget.getAttribute('href');
      if (href === '#') event.preventDefault();

      const subMenu = this.nextElementSibling;

      if (subMenu && subMenu.classList.contains('menu__sub-menu')) {
        if (subMenu.classList.contains('menu__sub-menu--open')) {
          subMenu.classList.remove('menu__sub-menu--open');
          this.classList.remove('open');
        } else {
          const openMenus = document.querySelectorAll('.menu__sub-menu--open');
          openMenus.forEach(menu => {
            menu.classList.remove('menu__sub-menu--open');
            menu.previousElementSibling.classList.remove('open');
          });
          subMenu.classList.add('menu__sub-menu--open');
          this.classList.add('open');
        }
      }
    }

    links.forEach(item => item.addEventListener('click', handleClick));
  },
  toggleSearch: function () {
    const btnSearchView = document.querySelectorAll('.toggle-search-view');

    function handleClick() {
      document.querySelector('header.header').classList.toggle('header--search-active');
    }

    btnSearchView.forEach(item => item.addEventListener('click', handleClick));
  },
  searchView: function () {
    const searchField = document.querySelector('.search-view input');
    const searchResult = document.querySelector('.search-view .search-view__result');

    if (!searchField && !searchResult) return;

    function onFocus() {
      searchResult.classList.add('search-view__result--open');
    }
    function onBlur() {
      searchResult.classList.remove('search-view__result--open');
    }

    searchField.addEventListener('focus', onFocus);
    searchField.addEventListener('blur', onBlur);
  },

  clearSearch: function () {
    const searchField = document.querySelector('.search-view input');
    const clearSearch = document.querySelector('.search-view__clear-search');
    const header = document.querySelector('header.header');

    if (!clearSearch) return;

    function handleClick() {
      if (searchField.value.length === 0 || searchField.value === '') {
        header.classList.remove('header--search-active');
      } else {
        searchField.value = '';
      }
    }

    function handleChange() {
      if (this.value.length === 0 || this.value === '') {
        clearSearch.classList.remove('search-view__clear-search--active');
      } else {
        clearSearch.classList.add('search-view__clear-search--active');
      }
    }

    clearSearch.addEventListener('click', handleClick);

    searchField.addEventListener('keyup', handleChange);
  },

  sortMenu: function () {
    this.createTemplateClone();
    this.reorganizeLevel2Menus();
    this.reorganizeLevel3Menus();
  },
  
  closeMenu: function () {
      var menuItens = document.querySelectorAll('.menu .menu__sub-menu ul a');
      
      menuItens.forEach(function (item) {
        item.addEventListener('click', function () {
          document.querySelector('div.menu').classList.remove('menu--open');
        });
      });
    },
    
  createTemplateClone: function () {
    const template = document.createElement('template');
    template.setAttribute('id', 'main-menu-clone');
    const menu = document.querySelector('div.menu');
    if (!menu) return;
    const menuClone = menu.cloneNode(true);
    template.content.appendChild(menuClone);
    document.body.appendChild(template);
  },

  reorganizeLevel2Menus: function () {
    const lvl2Lists = document.querySelectorAll('.menu nav > ul > li > ul');

    lvl2Lists.forEach(lvl2 => {
      const items = Array.from(lvl2.children);
      this.ensureMinimumItems(lvl2, items);
      this.createColumns(lvl2, items);
    });
  },

  ensureMinimumItems: function (lvl2, items) {
    if (items.length < 3) {
      const li = document.createElement('li');
      lvl2.appendChild(li);
    }
  },

  createColumns: function (lvl2, items) {
    if (items.length > 3) {
      const columns = [];
      const lastColumn = items[2];
      items.splice(0, 3);

      while (items.length) {
        columns.push(items.splice(0, items.length));
      }

      columns.forEach((column, index) => {
        const ul = document.createElement('ul');
        ul.classList.add('sub-menu__column');
        column.forEach(item => ul.appendChild(item));
        lastColumn.appendChild(ul);
      });
    }
  },

  reorganizeLevel3Menus: function () {
    const lvl3Lists = document.querySelectorAll('.menu nav > ul > li > ul > li > ul');

    lvl3Lists.forEach(lvl3 => {
      const items = Array.from(lvl3.children);
      const columns = this.createLevel3Columns(items);
      this.insertColumns(lvl3, columns);
    });
  },

  createLevel3Columns: function (items) {
    const columns = [];

    while (items.length) {
      columns.push(items.splice(0, 5));
    }

    return columns;
  },

  insertColumns: function (lvl3, columns) {
    lvl3.innerHTML = '';
    const next = lvl3.parentElement.nextElementSibling;

    columns.forEach((column, index) => {
      const ul = document.createElement('ul');
      ul.classList.add(`column-${index + 1}`);
      column.forEach(item => ul.appendChild(item));

      if (index === 0) {
        column.forEach(item => lvl3.appendChild(item));
      } else {
        next.prepend(ul);
      }
    });
  },
};

menu.main();
